module.exports = __webpack_public_path__ + "img/wrapbg1.d9f3d297.png";